import { EnhancedButtonStatus } from '@components/button/EnhancedButton';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ApiState {
  loading: Record<string, boolean>;
  error: Record<string, string | null>;
  buttonState: EnhancedButtonStatus;
}

const initialState: ApiState = {
  loading: {
    getProposals: false,
    getProposalFilters: false
  },
  buttonState: 'idle',
  error: {
    getProposals: ''
  }
};

const apiStateSlice = createSlice({
  name: 'apiState',
  initialState,
  reducers: {
    setButtonLoading: (state, action: PayloadAction<EnhancedButtonStatus>) => {
      state.buttonState = action.payload;
    },
    setLoading: (
      state,
      action: PayloadAction<{ key: string; value: boolean }>
    ) => {
      state.loading[action.payload.key] = action.payload.value;
    },
    setError: (
      state,
      action: PayloadAction<{ key: string; error: string | null }>
    ) => {
      state.error[action.payload.key] = action.payload.error;
    },
    clearApiStatus: (state, action: PayloadAction<{ key: string }>) => {
      delete state.loading[action.payload.key];
      delete state.error[action.payload.key];
      state.buttonState = 'idle';
    }
  }
});

export const { setButtonLoading, setLoading, setError, clearApiStatus } =
  apiStateSlice.actions;
const apiStateReducer = apiStateSlice.reducer;
export { apiStateReducer };
